<template>
  <div>
    <v-divider></v-divider>
    <table class="pa-3 mb-2" width="100%">
      <thead v-if="headers.length">
      <tr>
        <th
          width="35%"
          v-for="(head, index) of headers"
          :class="`${!index ? 'text-xs-left' : 'text-xs-center'}`"
          :key="index"
        >
          <small>
            {{ head }}
          </small>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item of data" :key="item.id || item.name">
        <td class="text-xs-left">
          <slot name="name" v-bind:item="item">
            <small>
              <b>{{ item.name }}</b>
            </small>
          </slot>
        </td>
        <td class="text-xs-center">
          <slot name="target" v-bind:item="item"/>
        </td>
        <td class="text-xs-center">
          <slot name="result" v-bind:item="item">
            <small>
              <b>{{ item.result }}</b>
            </small>
          </slot>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'recipeDataTable',
  props: {
    data: Array,
    headers: Array,
  },
};
</script>
